import React from 'react'

import EkgRecordingReviewScreen from '../../containers/EkgRecordingReviewScreen'
import styles from './PatientEkgRecording.css'

class PatientEkgRecording extends React.Component {
  UNSAFE_componentWillMount() {
    const {
      match,
    } = this.props
    this.props.setInitialPatientEkgRecordingData(match)
  }

  componentWillUnmount() {
    this.props.clearSelections()
  }
  render() {
    const {
      match,
      selectedRecordingId,
      selectedReassignInboxId,
      updateSelectedReassignInboxId,
      confirmAndArchiveCallback,
      reassignCallback,
    } = this.props


    return (
      <div
        data-page="patient-ekg-recording"
        className={styles.patientEkgRecording}
      >
        {selectedRecordingId &&
          <EkgRecordingReviewScreen
            showStackRemovalControl={false}
            recordingId={selectedRecordingId}
            reassignedInboxId={selectedReassignInboxId}
            updateReassignInboxId={updateSelectedReassignInboxId}
            confirmAndArchiveCallback={confirmAndArchiveCallback}
            reassignCallback={reassignCallback}
            match={match}
          />
        }
      </div>
    )
  }
}


export default PatientEkgRecording



// WEBPACK FOOTER //
// ./src/legacy/pages/PatientEkgRecording/PatientEkgRecording.jsx